import { useEffect, useRef, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';

export default function Book() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.ownerrez.com/widget.js';
    script.async = true;

    let observer: MutationObserver | null = null;

    script.onload = () => {
      const widgetContainer = widgetRef.current;
      if (widgetContainer) {
        observer = new MutationObserver(() => {
          if (widgetContainer.children.length > 0 || widgetContainer.innerHTML.trim().length > 0) {
            setIsLoading(false);
            if (observer) {
              observer.disconnect();
            }
          }
        });
        observer.observe(widgetContainer, {
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (widgetContainer.children.length > 0 || widgetContainer.innerHTML.trim().length > 0) {
          setIsLoading(false);
          if (observer) {
            observer.disconnect();
          }
        }
      }
    };

    document.body.appendChild(script);

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Container>
      <div style={{ position: 'relative', minHeight: '600px' }}>
        {isLoading && (
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '40%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Spinner variant='primary' />
          </div>
        )}
        <div
          ref={widgetRef}
          className="ownerrez-widget"
          data-propertyId="057fb907fae94ca7804a731f67407d6b"
          data-widget-type="Booking/Inquiry"
          data-widgetId="b5f6e8c18b9746aa882cd64e93a87ccc"
        />
      </div>
    </Container>
  );
}
